<template>
  <div style="width: 100%">
    <v-row>
      <v-col cols="12">
        <!-- Seleção da unidade -->
        <v-row>
          <select-simple-unidade
            :value="unidade"
            :mapeamento-id="diagnostico.mapeamento.id"
          />
        </v-row>

        <!-- unidade selecionada -->
        <div v-if="unidade">
          <!-- há desempenhos -->
          <div v-if="desempenhosUnidadeViabilizados.length">
            <!-- pies distribuição de cds por categoria -->
            <v-row>
              <v-col>
                <pie-chart-categoria-c-d-s
                  :com-sub-piechart="false"
                  :desempenhos="desempenhosUnidadeViabilizados"
                  :fonte="fontePieChart"
                  :titulo="tituloPieChart"
                  :is-get-svg="isGetSvg"
                  @svg="(value) => svg = value"
                />
              </v-col>
            </v-row>

            <!-- legenda do pie-chart -->
            <v-row class="justify-center">
              <legenda-cds />
            </v-row>

            <v-row>
              <v-col>
                <!-- tabela resultados -->
                <v-data-table
                  :headers="tabelaResultado.headers"
                  :items="desempenhosUnidadeViabilizadosTabelaResultados"
                  :search="tabelaResultado.opcoes.pesquisa"
                  :sort-by="tabelaResultado.opcoes.ordenarPor"
                  :sort-desc="tabelaResultado.opcoes.decrescente"
                  disable-pagination
                  hide-default-footer
                >
                  <!-- título, ordenação e filtros -->
                  <template v-slot:top>
                    <!-- título -->
                    <v-row class="mb-2">
                      <v-toolbar flat>
                        <v-toolbar-title>
                          <h2
                            class="
                              title
                              primary--text
                              text--darken-1 text-no-wrap
                            "
                          >
                            RESULTADOS
                          </h2>
                        </v-toolbar-title>
                      </v-toolbar>
                    </v-row>

                    <v-row>
                      <!-- ordenação -->
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <app-sort v-model="tabelaResultado.opcoes" />
                      </v-col>

                      <!-- filtro por situação -->
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-select
                          v-model="situacaoSelecionada"
                          :items="situacoes"
                          item-text="text"
                          label="Situação:"
                          prepend-icon="filter_list"
                          return-object
                        />
                      </v-col>

                      <!-- pesquisar -->
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <app-search v-model="tabelaResultado.opcoes" />
                      </v-col>
                    </v-row>
                  </template>

                  <!-- cds bold se >= 9 -->
                  <template v-slot:[`item.cds`]="{ item }">
                    <span :class="item.cds >= 9 ? 'font-weight-bold' : ''">{{
                      item.cdsStr
                    }}</span>
                  </template>

                  <!-- checkboxes de categoria de CDS -->
                  <template v-slot:[`item.naoAtende`]="{ item }">
                    <v-icon color="grey">
                      {{ item.iconNaoAtende }}
                    </v-icon>
                  </template>
                  <template v-slot:[`item.emDesenvolvimento`]="{ item }">
                    <v-icon color="grey">
                      {{ item.iconEmDesenvolvimento }}
                    </v-icon>
                  </template>
                  <template v-slot:[`item.atende`]="{ item }">
                    <v-icon color="grey">
                      {{ item.iconAtende }}
                    </v-icon>
                  </template>

                  <!-- média e desvio padrão -->
                  <template v-slot:[`body.append`]>
                    <!-- média -->
                    <tr>
                      <td align="right">
                        <strong
                          class="subtitle-2 grey--text text--darken-2"
                        >MÉDIA</strong>
                      </td>
                      <td align="center">
                        <strong>{{ meanCdsTabelaResultados }}</strong>
                      </td>
                      <td />
                      <td />
                      <td />
                    </tr>
                    <!-- desvio padrão -->
                    <tr>
                      <td align="right">
                        <strong
                          class="subtitle-2 grey--text text--darken-2"
                        >DESVIO PADRÃO</strong>
                      </td>
                      <td align="center">
                        <strong>{{ stdCdsTabelaResultados }}</strong>
                      </td>
                      <td />
                      <td />
                      <td />
                    </tr>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>

            <!-- tabela de resultados -->
            <v-row>
              <v-col>
                <tabela-resultados-c-d-s
                  :dados="dadosTabelaCds"
                  is-uma-unidade
                  titulo="QUADRO RESUMO DO CDS"
                />
              </v-col>
            </v-row>

            <v-row v-if="desempenhosUnidadeInviabilizados.length">
              <v-col>
                <!-- tabela inviabilizados -->
                <v-data-table
                  :headers="tabelaInviabilizados.headers"
                  :items="desempenhosUnidadeInviabilizados"
                  :search="tabelaInviabilizados.opcoes.pesquisa"
                  :sort-by="tabelaInviabilizados.opcoes.ordenarPor"
                  :sort-desc="tabelaInviabilizados.opcoes.decrescente"
                  disable-pagination
                  hide-default-footer
                >
                  <!-- título, ordenação e filtros -->
                  <template v-slot:top>
                    <!-- título -->
                    <v-row class="mb-2">
                      <v-toolbar flat>
                        <v-toolbar-title>
                          <h2
                            class="
                              title
                              primary--text
                              text--darken-1 text-no-wrap
                            "
                          >
                            CDS INVIABILIZADOS
                          </h2>
                        </v-toolbar-title>
                      </v-toolbar>
                    </v-row>

                    <v-row>
                      <!-- ordenação -->
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <app-sort v-model="tabelaInviabilizados.opcoes" />
                      </v-col>

                      <v-col />

                      <!-- pesquisar -->
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <app-search v-model="tabelaInviabilizados.opcoes" />
                      </v-col>
                    </v-row>
                  </template>

                  <!-- checkboxes de causas de inviabilização -->
                  <template
                    v-slot:[`item.comportamentalViabilizado`]="{ item }"
                  >
                    <v-icon color="grey">
                      {{ item.iconResultadoComportamental }}
                    </v-icon>
                  </template>
                  <template v-slot:[`item.tecnicoViabilizado`]="{ item }">
                    <v-icon color="grey">
                      {{ item.iconResultadoTecnico }}
                    </v-icon>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>

            <v-row class="justify-end mb-1">
              <v-tooltip
                max-width="400"
                top
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mr-2"
                    color="success"
                    @click="getRelatorio()"
                    v-on="on"
                  >
                    <v-icon>get_app</v-icon>
                    BAIXAR PDF
                  </v-btn>
                </template>
                <span>Clique para baixar o relatório dos dados em formato PDF.</span>
              </v-tooltip>
            </v-row>
          </div>

          <!-- não tem resultado viabilizado -->
          <v-row v-else-if="unidade.selecionado">
            <v-col>
              <app-alert
                icon="info"
                :message="resultadoInviabilizado"
                type="info"
              />
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import { mean, std } from 'mathjs';
import { generatePDF, preparePdf, convertSvg } from '@/modules/relatorioPDF';
import AppAlert from '@/components/core/AppAlert';
import AppSort from '@/components/core/AppSort';
import AppSearch from '@/components/core/AppSearch';
import SelectSimpleUnidade from '@/components/SelectSimpleUnidade';
import PieChartCategoriaCDS from '@/components/monitoramento/desempenho/cds/PieChartCategoriaCDS';
import LegendaCds from '@/components/monitoramento/desempenho/cds/LegendaCds';
import TabelaResultadosCDS from '@/components/monitoramento/desempenho/cds/TabelaResultadosCDS';
import Data from '@/modules/data';
import toDecimal from '@/filters/decimal';

export default {
  name: 'RelatorioGerencialCoeficienteDesempenhoUnidade',

  components: {
    AppAlert,
    AppSort,
    AppSearch,
    SelectSimpleUnidade,
    PieChartCategoriaCDS,
    LegendaCds,
    TabelaResultadosCDS,
  },

  props: {
    diagnostico: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      unidade: { selecionado: null },
      tabelaResultado: {
        headers: [
          {
            text: 'SERVIDOR',
            value: 'usuario.nome',
            width: '40%',
            sortable: false,
          },
          {
            text: 'RESULTADO CDS',
            value: 'cds',
            width: '15%',
            sortable: false,
            align: 'center',
          },
          {
            text: 'NÃO ATENDE',
            value: 'naoAtende',
            width: '15%',
            sortable: false,
            align: 'center',
          },
          {
            text: 'EM DESENVOLVIMENTO',
            value: 'emDesenvolvimento',
            width: '15%',
            sortable: false,
            align: 'center',
          },
          {
            text: 'ATENDE',
            value: 'atende',
            width: '15%',
            sortable: false,
            align: 'center',
          },
        ],
        opcoes: {
          pesquisa: '',
          decrescente: false,
          ordenarPor: 'usuario.nome',
          selecionado: { id: 'usuario.nome', descricao: 'Nome do Servidor' },
          lista: [
            { id: 'usuario.nome', descricao: 'Nome do Servidor' },
            { id: 'cds', descricao: 'Resultado CDS' },
          ],
        },
      },
      situacoes: [
        { categoria: 'TODAS', text: 'Todas' },
        { categoria: 'NAO_ATENDE', text: 'Não Atende' },
        { categoria: 'EM_DESENVOLVIMENTO', text: 'Em Desenvolvimento' },
        { categoria: 'ATENDE', text: 'Atende' },
      ],
      situacaoSelecionada: { categoria: 'TODAS', text: 'Todas' },
      tabelaInviabilizados: {
        headers: [
          {
            text: 'SERVIDOR',
            value: 'usuario.nome',
            width: '60%',
            sortable: false,
          },
          {
            text: 'RESULTADO COMPORTAMENTAL',
            value: 'comportamentalViabilizado',
            width: '20%',
            sortable: false,
            align: 'center',
          },
          {
            text: 'RESULTADO TÉCNICO',
            value: 'tecnicoViabilizado',
            width: '20%',
            sortable: false,
            align: 'center',
          },
        ],
        opcoes: {
          pesquisa: '',
          decrescente: false,
          ordenarPor: 'usuario.nome',
          selecionado: { id: 'usuario.nome', descricao: 'Nome do Servidor' },
          lista: [
            { id: 'usuario.nome', descricao: 'Nome do Servidor' },
            { id: 'cds', descricao: 'Resultado CDS' },
          ],
        },
      },
      resultadoInviabilizado:
        'Resultado inviabilizado (Ausência do resultado comportamental) (Ausência do resultado técnico).',
      isGetSvg: false,
      svg: null,
    };
  },

  computed: {
    ...mapState({
      desempenhos: (state) => state.monitoramentoDesempenho.desempenhos,
    }),
    meanCdsTabelaResultados() {
      if (this.desempenhosUnidadeViabilizadosTabelaResultados.length) {
        const mean = _.meanBy(this.desempenhosUnidadeViabilizadosTabelaResultados, 'cds');

        return `${mean.toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 })}`;
      }

      return null;
    },
    stdCdsTabelaResultados() {
      if (this.desempenhosUnidadeViabilizadosTabelaResultados.length) {
        const _std = std(this.desempenhosUnidadeViabilizadosTabelaResultados.map((d) => d.cds));
        return `${_std.toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 })}`;
      }
      return null;
    },
    tituloPieChart() {
      return `Comparativo de CDS dos Servidores da ${this.unidade.selecionado.sigla}`;
    },
    fontePieChart() {
      return `Fonte: Sistema Desenvolva, ${this.diagnostico.ano}`;
    },
    desempenhosUnidade() {
      if (this.unidade.selecionado) {
        return this.desempenhos.filter((d) => d.unidade.id === this.unidade.selecionado.idVersao);
      }
      return [];
    },
    desempenhosUnidadeViabilizadosTabelaResultados() {
      return this.desempenhosUnidadeViabilizados
        .filter(
          (d) => this.situacaoSelecionada.categoria === 'TODAS'
          || d.cdsCategoria === this.situacaoSelecionada.categoria,
        )
        .map((d) => ({
          ...d,
          cdsStr: `${d.cds.toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 })}`,
          iconNaoAtende: this.checkBoxIcon(d.cdsCategoria === 'NAO_ATENDE'),
          iconEmDesenvolvimento: this.checkBoxIcon(d.cdsCategoria === 'EM_DESENVOLVIMENTO'),
          iconAtende: this.checkBoxIcon(d.cdsCategoria === 'ATENDE'),
        }));
    },
    desempenhosUnidadeViabilizados() {
      return this.desempenhosUnidade.filter((d) => this.isCdsViabilizado(d));
    },
    desempenhosUnidadeInviabilizados() {
      return this.desempenhosUnidade
        .filter((d) => !this.isCdsViabilizado(d) && !d.foiDispensado)
        .map((d) => ({
          ...d,
          iconResultadoComportamental: this.checkBoxIcon(
            d.teveAutoavaliacaoComportamental && d.teveAvaliacaoGestorComportamental,
          ),
          iconResultadoTecnico: this.checkBoxIcon(
            d.teveAutoavaliacaoResponsabilidade && d.teveAvaliacaoGestorResponsabilidade,
          ),
        }));
    },
    dadosTabelaCds() {
      const dados = [];
      if (this.unidade.selecionado) {
        const desempenhos = this.desempenhosUnidadeViabilizados
          .filter((d) => d.unidade.id === this.unidade.selecionado.idVersao);

        dados.push({
          unidade: this.unidade.selecionado,
          nServidoresNaoAtende: desempenhos.filter((d) => d.cdsCategoria === 'NAO_ATENDE').length,
          nServidoresEmDesenvolvimento: desempenhos.filter((d) => d.cdsCategoria === 'EM_DESENVOLVIMENTO').length,
          nServidoresAtende: desempenhos.filter((d) => d.cdsCategoria === 'ATENDE').length,
          mediaCds: desempenhos.length > 0 ? mean(desempenhos.map((d) => d.cds)) : 0,
          desvioPadraoCds: desempenhos.length > 0 ? std(desempenhos.map((d) => d.cds)) : 0,
        });
      }

      return { linhas: dados };
    },
  },

  methods: {
    checkBoxIcon(isChecked) {
      return isChecked ? 'check_box' : 'check_box_outline_blank';
    },
    isCdsViabilizado(d) {
      return (
        !d.foiDispensado
        && d.teveAutoavaliacaoComportamental
        && d.teveAvaliacaoGestorComportamental
        && d.teveAutoavaliacaoResponsabilidade
        && d.teveAvaliacaoGestorResponsabilidade
      );
    },
    async getRelatorio() {
      this.isGetSvg = true;
      await preparePdf(async () => {
        const inicioComportamental = Data.format(this.diagnostico.inicioComportamental);
        const fimComportamental = Data.format(this.diagnostico.fimComportamental);
        const inicioResponsabilidade = Data.format(this.diagnostico.inicioResponsabilidadeChefia);
        const fimResponsabilidade = Data.format(this.diagnostico.fimResponsabilidadeServidor);

        const documento = {
          nome: `relatorio-monitoramento-coeficiente-desempenho-unidade-${
            this.unidade.selecionado.sigla.toLowerCase()}-${this.diagnostico.id}`,
          cabecalho: {
            titulo: 'Coeficiente de Desempenho da Unidade',
            itens: [
              `Diagnóstico: ${this.diagnostico.nome}`,
              `Período de avaliação comportamental: ${inicioComportamental} a ${fimComportamental}`,
              `Período de avaliação de responsabilidades: ${inicioResponsabilidade} a ${fimResponsabilidade}`,
              `Unidade: ${this.unidade.selecionado.nome} (${this.unidade.selecionado.sigla})`,
            ],
          },
          blocos: [
            {
              titulo: 'GRÁFICOS',
              itens: [
                { tipo: 'imagem', valor: await convertSvg(this.svg) },
              ],
            },
            {
              titulo: 'QUADRO RESUMO',
              itens: [{
                tipo: 'tabela',
                valor: {
                  simples: true,
                  colunas: [
                    'UNIDADE',
                    'SERVIDORES\nCOM CDS\nNÃO ATENDE',
                    'SERVIDORES\nCOM CDS EM\nDESENVOLVI-\nMENTO',
                    'SERVIDORES\nCOM CDS \nATENDE',
                    'MÉDIA CDS\nDA UNIDADE',
                    'DESVIO PADRÃO\nDA UNIDADE',
                  ],
                  linhas: this.dadosTabelaCds.linhas.map((d) => [
                    `${d.unidade.nome} (${d.unidade.sigla})`,
                    d.nServidoresNaoAtende,
                    d.nServidoresEmDesenvolvimento,
                    d.nServidoresAtende,
                    toDecimal(d.mediaCds),
                    toDecimal(d.desvioPadraoCds),
                  ]),
                },
              }],
            },
            {
              titulo: 'RESULTADOS VIABILIZADOS',
              itens: [{
                tipo: 'tabela',
                valor: {
                  colunas: [
                    'SERVIDOR',
                    'RESULTADO\nCDS',
                    'SITUAÇÃO\nCDS',
                  ],
                  linhas: this.desempenhosUnidadeViabilizadosTabelaResultados.map((d) => [
                    d.usuario.nome,
                    toDecimal(d.cds),
                    this.getSituacaoCds(d.cdsCategoria),
                  ]),
                },
              }],
            },
            {
              itens: [{
                tipo: 'tabela',
                valor: {
                  simples: true,
                  largura: 100,
                  colunas: ['RESUMO', 'CDS'],
                  linhas: [
                    [
                      'MÉDIA',
                      toDecimal(mean(this.desempenhosUnidadeViabilizadosTabelaResultados.map((d) => d.cds))),
                    ],
                    [
                      'DESVIO PADRÃO',
                      toDecimal(std(this.desempenhosUnidadeViabilizadosTabelaResultados.map((d) => d.cds))),
                    ],
                  ],
                },
              }],
            },
          ],
        };

        if (this.desempenhosUnidadeInviabilizados.length > 0) {
          documento.blocos.push({
            titulo: 'RESULTADOS INVIABILIZADOS',
            itens: [{
              tipo: 'tabela',
              valor: {
                colunas: [
                  'SERVIDOR',
                  'RESULTADO\nCOMPORTAMENTAL',
                  'RESULTADO\nTÉCNICO',
                ],
                linhas: this.desempenhosUnidadeInviabilizados.map((d) => [
                  d.usuario.nome,
                  d.comportamentalInviabilizado ? 'Não' : 'Sim',
                  d.tecnicoInviabilizado ? 'Não' : 'Sim',
                ]),
              },
            }],
          });
        }

        generatePDF(documento);
      });
      this.isGetSvg = false;
    },
    getSituacaoCds(situacao) {
      if (situacao === 'ATENDE') {
        return 'Atende';
      }
      if (situacao === 'EM_DESENVOLVIMENTO') {
        return 'Em Desenvolvimento';
      }
      return 'Não Atende';
    },
  },
};
</script>

<style scoped>
.chart {
  width: 100%;
  max-height: 400px;
  font-family: Roboto, sans-serif;
}
</style>
